/* global angular */
( function () {
	'use strict';

	function Group ( ) {
		return {
			'templateUrl'      : '/templates/components/group/group.html',
			'restrict'         : 'E',
			'replace'          : true,
			'controller'       : 'Group',
			'controllerAs'     : 'vm',
			'bindToController' : true,
			'scope'            : {
				'mode'               : '@',
				'onDelete'           : '&',
				'templateModel'      : '=',
				'model'              : '=',
				'index'              : '=',
				'template'           : '=',
				'canDelete'          : '=',
				'allIndicatorStates' : '=',
				'editPrivilege'      : '=',
				'viewOnlyMode'       : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'group', Group );
} )( );
